



























































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import BuySellFXRequest from '@/models/Accounts/DepositAccounts/Wallets/BuySellFXRequest';

@Component({ name: 'QuoteCountdown', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    isRequoteButtonVisible: boolean = false;
    countdownTimer: number;
    countdownValue: number = 20;
    sellExchangeRate: number;
    commissionFee: number = 0.05;
    buyExchangeRate: number;
    exchangeExample: string = '';

    @Prop({required: true})
    account: DepositAccountSummary;

    @Prop({required: true})
    buySellFXRequest: BuySellFXRequest;

    @Prop({required: true})
    currentPage: number;

    @Watch('currentPage')
    async onPageChanged(pageNumber: number) {
        if (pageNumber === 2) {
            this.getNewQuote();
        }
        else {
            clearInterval(this.countdownTimer);
        }
    }

    @Watch('countdownValue')
    async onCountdownChanged(value: number) {
        if (value === 0) {
            this.expireQuote();
        }
    }

    get sourceWalletName() {
        if (!this.buySellFXRequest.sourceWalletId) {
            return "Unknown wallet";
        }
        else {
            const wallet = this.account.wallets.find(wallet => wallet.id === this.buySellFXRequest.sourceWalletId);
            return wallet.default ? "Default Wallet" : wallet.name;
        }
    }

    get destinationWalletName() {
        if (!this.buySellFXRequest.destinationWalletId) {
            return "Unknown wallet";
        }
        else {
            const wallet = this.account.wallets.find(wallet => wallet.id === this.buySellFXRequest.destinationWalletId);
            return wallet.default ? "Default Wallet" : wallet.name;
        }
    }

    getNewQuote() {
        this.isRequoteButtonVisible = false;
        this.countdownValue = 20;

        // Get the latest exchange rates, values are hardcoded based on the buy/sell currencies for now
        // so that they are more realistic depending on the scenario, but in the future this needs to be an API call
        // NOTE: These values are all based on the selling currency/source currency being GBP
        if (this.buySellFXRequest.buyCurrency === 'EUR' || this.buySellFXRequest.buyCurrency === 'CHF') {
            this.sellExchangeRate = 0.88;
            this.buyExchangeRate = 1.13;
        }
        // Fake currency exchange for XPT which we are treating as BTC
        else if (this.buySellFXRequest.buyCurrency === 'XPT') {
            this.sellExchangeRate = 23058.37;
            this.buyExchangeRate = 0.000043;
        }
        // Fake currency exchange for XPD which we are treating as ETH
        else if (this.buySellFXRequest.buyCurrency === 'XPD') {
            this.sellExchangeRate = 11468.72;
            this.buyExchangeRate = 0.00068;
        }
        // Fallback values
        else {
            this.sellExchangeRate = 0.8547;
            this.buyExchangeRate = 1.1723;
        }

        if (this.buySellFXRequest.buySellDirection === 'Selling') {
            this.exchangeExample = (1 / this.sellExchangeRate).toString();
        }
        else {
            this.exchangeExample = (1 / this.buyExchangeRate).toString();
        }

        // Reset the destination amount based on new rates
        if (this.buySellFXRequest.buySellDirection === 'Selling') {
            this.buySellFXRequest.destinationAmount.amount = (parseFloat(this.buySellFXRequest.sourceAmount.amount) / this.sellExchangeRate).toFixed(0);
        }
        else {
            this.buySellFXRequest.destinationAmount.amount = (parseFloat(this.buySellFXRequest.sourceAmount.amount) / this.buyExchangeRate).toFixed(0);
        }
        this.buySellFXRequest.feeAmount.currency = this.buySellFXRequest.sourceAmount.currency
        this.buySellFXRequest.feeAmount.amount = (parseFloat(this.buySellFXRequest.sourceAmount.amount) * this.commissionFee).toFixed(0);

        // Restart the countdown, updates every 1 second
        this.countdownTimer = setInterval(this.updateCountdown, 1000);
    }

    expireQuote() {
        this.isRequoteButtonVisible = true;
        this.buySellFXRequest.acceptedQuote = false;
        clearInterval(this.countdownTimer);
    }

    updateCountdown() {
        this.countdownValue -= 1;
    }

}
